import { useEffect, Component } from "react";
import { Axios, ApiUrl } from "../../components";
import { userSignOut } from "actions/Auth";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

const { DASHBOARD } = ApiUrl;

class LoginChecker extends Component {
  componentDidMount() {
    if (localStorage.getItem("user_id")) {
      Axios.get(DASHBOARD).then((response) => {
        if (response.data && response.data.error_code === 5004) {
          this.props.userSignOut();
        }
      });
    }
  }
  render() {
    return null;
  }
}

export default connect(null, { userSignOut })(withRouter(LoginChecker));
